var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePenSolid2ActiveAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25195 5.16498C2.25195 3.90865 3.27339 2.88721 4.52973 2.88721H10.2242V7.44276C10.2242 8.07271 10.7331 8.58165 11.3631 8.58165H15.9186V13.0553L12.8294 16.1446C12.4628 16.5112 12.2066 16.9667 12.082 17.4685L11.4164 20.1343C11.3346 20.4617 11.3524 20.8034 11.4627 21.113H4.52973C3.27339 21.113 2.25195 20.0915 2.25195 18.8352V5.16498ZM15.9186 7.44276H11.3631V2.88721L15.9186 7.44276ZM21.8195 11.2758L22.332 11.7883C22.8872 12.3435 22.8872 13.244 22.332 13.8027L21.2856 14.8491L18.7587 12.3222L19.8051 11.2758C20.3603 10.7206 21.2607 10.7206 21.8195 11.2758ZM13.3526 17.7284L17.9508 13.1301L20.4777 15.657L15.8795 20.2517C15.7335 20.3976 15.552 20.5008 15.3492 20.5507L13.2102 21.0845C13.0145 21.1343 12.8116 21.0774 12.6692 20.935C12.5269 20.7927 12.4699 20.5898 12.5197 20.3941L13.0536 18.2551C13.1034 18.0558 13.2066 17.8707 13.3526 17.7248V17.7284Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePenSolid2ActiveAssignment);
export default __webpack_public_path__ + "static/media/file-pen-solid 2Active-Assignment.d7b4e483aaa37d05cb1bf21ea7546989.svg";
export { ForwardRef as ReactComponent };